import React from 'react'
import DataObjectIcon from '@mui/icons-material/DataObject'
import BaseWidgetProvider from '../base/BaseWidgetProvider'
import KeyValueWidget from './KeyValueWidget'
import { Box } from '@mui/material'

/**
 * Provider for KeyValueWidget.
 * Handles widget registration, configuration, and instantiation.
 * @extends BaseWidgetProvider
 */
class KeyValueWidgetProvider extends BaseWidgetProvider {
  /**
   * Unique code for the widget
   * @returns {string}
   */
  getCode = () => 'KeyValueWidgetProvider'

  /**
   * Display name of the widget
   * @param {Object} globalData - Global data context
   * @param {Object} config - Widget configuration
   * @returns {string}
   */
  getName = (globalData, config) => {
    if (config && config.label) {
      return config.label
    }
    return 'Real-Time Value'
  }

  /**
   * Icon for the widget
   * @returns {React.Component}
   */
  getIcon = () => DataObjectIcon

  /**
   * Creates the widget instance
   * @param {Object} props - Widget properties
   * @returns {React.Component}
   */
  createWidget = (props) => <KeyValueWidget {...props} />

  /**
   * Creates a preview instance of the widget
   * @param {Object} props - Widget properties
   * @returns {React.Component}
   */
  createPreviewWidget = (props) => (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <DataObjectIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
      <Box sx={{ mt: 1, color: 'text.secondary' }}>Key-Value Widget</Box>
    </Box>
  )

  // Default dimensions
  size = { defaultW: 2, defaultH: 2, minW: 2, minH: 2, maxW: 4, maxH: 4 }

  /**
   * Returns widget information for the grid
   * @param {number} columns
   * @param {number} cellHeight
   * @returns {Object}
   */
  getWidgetInfo = (columns, cellHeight) => {
    return {
      ...super.getWidgetInfo(columns, cellHeight, this.size),
      availableWithoutDevice: true,
      hideHeader: false
    }
  }

  /**
   * Returns configuration fields for the widget
   * @returns {Array<Object>}
   */
  getConfigurationInfo = () => {
    return [
      {
        key: 'key',
        type: 'text',
        label: 'Key of the Value',
        defaultValue: ''
      },
      {
        key: 'label',
        type: 'text',
        label: 'Visual Label',
        defaultValue: 'Example Value'
      }
    ]
  }
}

export default KeyValueWidgetProvider
